import { useEffect, useState } from "react";
import { SbBlokData } from "@storyblok/react";
import "pure-react-carousel/dist/react-carousel.es.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import theme from "../constants/themes";
import { CAROUSEL_TRANSITION_DELAY, CAROUSEL_TRANSITION_TIMING } from "../constants/variables";
import { getStyleCss } from "../helper/css_style";
import CustomStoryBlockComponent from "./CustomStoryBlockComponent";
import { IconV2 } from "./V2/atoms/IconV2/IconV2";

interface HeroCarouselProps {
  blok: SbBlokData;
}

function HeroCarousel({ blok }: HeroCarouselProps) {
  let styles = {};
  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
  }
  const [autoplay, setAutoPlay] = useState(false);

  const arrowStyles = {
    position: "absolute",
    zIndex: 2,
    top: `${blok.arrowPosition === "topRight" ? "-60px" : "calc(50% - 15px)"}`,
    width: 30,
    height: 30,
    cursor: "pointer",
    margin: "0px 2%",
    color: `${blok.arrowColor ? blok.arrowColor : theme.lightMode.primaryWhite}`
  };

  const indicatorStyles = {
    background: `${blok.indicatorColor ? blok.indicatorColor : "white"}`,
    width: 38,
    height: 4,
    margin: `${blok.indicatorMargin ? blok.indicatorMargin : "0 8px"}`,
    borderRadius: "5px",
    opacity: "0.3",
    display: `${blok.indicatorVisibility === "none" ? "none" : "inline-block"}`
  };

  const baseChildren = (
    <div>
      {blok?.ItemList?.map((nestedBlok) => (
        <CustomStoryBlockComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  );

  useEffect(() => {
    setTimeout(setAutoPlay(true), 10000);
  }, []);

  return (
    <section style={styles} className="relative h-auto">
      <Carousel
        showThumbs={false}
        showStatus={false}
        transitionTime={CAROUSEL_TRANSITION_TIMING}
        interval={CAROUSEL_TRANSITION_DELAY}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, left: 15 }}>
              <IconV2
                blok={{
                  component: "icon",
                  icon: "chevron-left-orange",
                  height: 20,
                  width: 20,
                  alt: "chevron Left Arrow"
                }}
              />
            </button>
          )
        }
        style={{ paddingBottom: "50px" }}
        autoPlay={autoplay}
        infiniteLoop
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: 15 }}>
              <IconV2
                blok={{
                  component: "icon",
                  icon: "chevron-right-orange",
                  height: 20,
                  width: 20,
                  alt: "chevron Right Arrow"
                }}
              />
            </button>
          )
        }
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                style={{
                  ...indicatorStyles,
                  opacity: "1"
                }}
                aria-label={`Selected: ${label} ${index + 1}`}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              style={indicatorStyles}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              title={`${label} ${index + 1}`}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {baseChildren?.props?.children}
      </Carousel>
      {/* <img className="wave-position" src={blok?.waveImage} alt="" /> */}
    </section>
  );
}

export default HeroCarousel;